import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import FAQ from '../components/FAQ';

const VoluntaryFreezingPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='page-content'>
      <SEO
        title='Policy for Voluntary Freezing or Blocking of Trading Account'
        description='Learn how to voluntarily freeze or block your trading account at Gateway Financial Services in case of suspicious activities.'
      />
      <section
        className='pwu-hero-bg text-white position-relative'
        style={{
          backgroundImage:
            "linear-gradient(rgba(12, 59, 68, 0.7), rgba(12, 59, 68, 0.7)), url('/images/banners/contactus-banner.webp')",
        }}
      >
        <div className='container position-relative' style={{ zIndex: 10 }}>
          <div className='row'>
            <div className='col-lg-8'>
              <h1 className='pwu-hero-title mb-4'>Freezing/Blocking Policy</h1>
            </div>
          </div>
        </div>
      </section>

      <section id='welcome-section'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-12' style={{ textAlign: 'left' }}>
              <h3 className='mb-4'>
                Policy for Voluntary Freezing or Blocking of Your Trading
                Account
              </h3>

              <h5>1. Background</h5>
              <p>
                In compliance with SEBI vide circular no.
                SEBI/HO/MIRSD/POD-1/P/CIR/2024/4 dated January 12, 2024, and NSE
                Circular no NSE/INSP/61529 Dated April 08, 2024 regarding the
                framework for Trading Members to provide the facility of
                voluntary freezing/blocking of online access of the trading
                account to their clients.
              </p>
              <ul className='listitem'>
                <li>
                  Freezing/blocking is only for the online access to the
                  client’s trading account, and there shall be no restrictions
                  on the Risk Management activities of the Trading Member.
                </li>
                <li>
                  The request for freezing/blocking does not constitute a
                  request for marking the client’s Unique Client Code (UCC) as
                  inactive in the Exchange records.
                </li>
              </ul>

              <h5 className='mt-4'>2. Modus Operandi for Freezing/Blocking</h5>
              <p>
                We provide the following methods of communication through which
                the client may request for voluntary freezing/blocking of the
                online access of trading account if any suspicious activity is
                observed in the trading account:
              </p>

              <h6 className='mt-3'>a) Email from registered e-mail ID:</h6>
              <p>
                A dedicated email ID <strong>stoptrade@gatewayfin.in</strong>{' '}
                has been opened where a client can send their request for
                freezing/blocking from their email ID registered with us.
                Clients are requested to send their freezing/blocking request
                without any ambiguity along with their UCC. Similarly for
                un-freezing/un-blocking, clients are requested to send their
                request to the email ID <strong>stoptrade@gatewayfin.in</strong>
                .
              </p>

              <h6 className='mt-3'>b) SMS from registered mobile number:</h6>
              <p>
                A dedicated mobile number <strong>+91 9007088083</strong> has
                been assigned where a client can send their request for
                freezing/blocking from their mobile number registered with us.
              </p>
              <div
                className='p-3 mb-3'
                style={{
                  backgroundColor: '#f8f9fa',
                  borderLeft: '4px solid #0c3b44',
                }}
              >
                <p className='mb-2'>
                  <strong>For freezing/blocking:</strong> Type “BLOCK” FOLLOWED
                  BY UCC WITHOUT SPACE.
                  <br />
                  <span className='text-muted' style={{ fontSize: '0.9em' }}>
                    <em>
                      Example: if your UCC is A123 then the message will be
                      “BLOCKA123” and send it to +91 9007088083.
                    </em>
                  </span>
                </p>
                <p className='mb-0'>
                  <strong>For un-freezing/un-blocking:</strong> Type “UNBLOCK”
                  FOLLOWED BY UCC WITHOUT SPACE.
                  <br />
                  <span className='text-muted' style={{ fontSize: '0.9em' }}>
                    <em>
                      Example: if your UCC is W114X101 then the message will be
                      “UNBLOCKW114X101” and send it to +91 9007088083.
                    </em>
                  </span>
                </p>
              </div>
              <p className='text-danger font-weight-bold'>
                Note: Requests sent for freezing/blocking and
                un-freezing/un-blocking will not be processed by the company if
                they are not sent from the client’s registered mobile number or
                registered email ID.
              </p>

              <h5 className='mt-4'>3. Action Taken by the Company</h5>
              <p>
                The company shall take the following actions upon receipt of
                such a request for freezing/blocking the online access of the
                trading account:
              </p>
              <ul className='listitem'>
                <li>
                  Verify whether the request is received from the registered
                  mobile number/e-mail ID of the client.
                </li>
                <li>
                  Freeze/block the online access of the client's trading account
                  and simultaneously cancel all the pending orders, if any, of
                  the said client.
                </li>
                <li>
                  Issue an acknowledgement to the registered email ID or mobile
                  number of the client stating that the online access to the
                  trading account has been frozen/blocked and all pending
                  orders, if any, have been cancelled.
                </li>
                <li>
                  Details of open positions (if any) will also be communicated
                  to the registered email ID of the client along with contract
                  expiry information within one hour from the freezing/blocking
                  of the trading account.
                </li>
              </ul>

              <h6 className='mt-3'>Timelines for Processing:</h6>
              <div className='cu-table-container my-3'>
                <table className='cu-table mb-0'>
                  <thead>
                    <tr>
                      <th style={{ width: '40%' }}>Scenario</th>
                      <th style={{ width: '60%' }}>
                        Timelines for issuing acknowledgement and
                        freezing/blocking of online access
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Request received during the trading hours and within 15
                        minutes before the start of trading
                      </td>
                      <td>Within 15 minutes of receiving the request.</td>
                    </tr>
                    <tr>
                      <td>
                        Request received after the trading hours and 15 minutes
                        before the closure of trading hour.
                      </td>
                      <td>Before the start of the next trading session.</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h5 className='mt-4'>4. Re-enabling Online Access</h5>
              <p>
                The Trading Member shall re-enable the online access of the
                trading account after carrying out necessary due diligence,
                including validating the client request and
                unfreezing/unblocking the online access of the trading account.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id='app-section'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 align-self-center'>
              <h3 data-aos='fade'>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href='#download' className='lm-btn'>
                Download &amp; Explore More
              </a>
            </div>
            <div className='col-lg-6'>
              <img
                src='/images/download.avif'
                className='img-fluid'
                alt='Download App Preview'
              />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default VoluntaryFreezingPolicy;
